import { Button } from "../../../components/Button";
import { SectionSubTitle } from "../../../components/SectionTitle";
import { Spacer } from "../../../components/Spacer";
import { CameraSvg } from "../../../components/Svg/Icons/Camera";
import { SleepSvg } from "../../../components/Svg/Icons/Sleep";
import { FadeLeft } from "../../../components/Transitions/FadeLeft";
import { FadeRight } from "../../../components/Transitions/FadeRight";
import { FadeUp } from "../../../components/Transitions/FadeUp";

export const MeetingPoint = () => {
  return (
    <>
      <FadeUp>
        <SectionSubTitle title=" Dos orígenes, un destino" />

        <Spacer />
        <Spacer />

        <div className="max-w-220 m-auto flex justify-center items-center flex-col text-3xl">
          <img
            alt="Map"
            src="/mundo.png"
            width="920"
            className="soft-card rounded-4xl p-3"
          />
        </div>

        <Spacer />

        <div className="text-primary-text text-center text-lg md:text-xl opacity-90 max-w-3xl m-auto p-4 leading-relaxed">
          Hemos reunido toda la información necesaria para que podáis aprovechar
          al máximo vuestra visita y estancia en Sevilla.
        </div>
      </FadeUp>
      <Spacer />
      <Spacer />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-8 max-w-120 m-auto">
        <FadeLeft>
          <div className="flex justify-center h-1/1">
            <Button
              bgColor="white"
              textColor="primary-text"
              borderColor="primary-text"
              to={{
                href: "https://drive.google.com/file/d/1ICa3tbOmAyUlni_jBCFLFMPTEGEpkIwb/view?usp=drive_link",
                target: "_blank",
              }}
              className="text-xl md:text-2xl shadow-md"
              icon={<SleepSvg width="45px" color="var(--color-primary-text)" />}
            >
              Info Hoteles
            </Button>
          </div>
        </FadeLeft>

        <FadeRight>
          <div className="flex justify-center h-1/1">
            <Button
              bgColor="white"
              textColor="primary-text"
              borderColor="primary-text"
              to={{
                href: "https://drive.google.com/file/d/1CWv2DFsRs_SgqE2qFUaSPCOeJ-CIGOl5/view?usp=drive_link",
                target: "_blank",
              }}
              className="text-xl md:text-2xl shadow-md"
              icon={
                <CameraSvg width="45px" color="var(--color-primary-text)" />
              }
            >
              Guía Turística
            </Button>
          </div>
        </FadeRight>
      </div>
    </>
  );
};
